import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Spin,
  Select,
  DatePicker,
  Checkbox,
  Form,
  Input,
  Button,
  Table,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getOmsStockSummary } from "../../redux/actions/omsStockSummary.action";
import {
  getGenderCategory,
  getGenderCategoryChange,
} from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategoryNew } from "../../redux/actions/fitCategory.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action";
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import { getStyle, getStyleChange } from "../../redux/actions/style";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { Link, useHistory } from "react-router-dom";
import { Excel } from "antd-table-saveas-excel";
import Loader from "react-loader-spinner";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
import { getFabricStock } from "../../redux/actions/fabricStock.action";

const dateFormatList = ["MM-DD-YYYY"];

const FabricStock = ({ token }) => {
  TabTitle("Fabric Stock");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    getWiseStockReport,
    productType,
    gender,
    genderCategory,
    season,
    productStatus,
    productClass,
    size,
    wash,
    fitCategory,
    fitCategoryNew,
    fabricStockReport,
    genderCategoryChange,
    styleChange,
    Sku,
    seasonYear,
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [productClassID, setProductClassID] = useState([]);
  const [seasonID, setSeasonID] = useState([]);
  const [isChecked, setIsChecked] = useState([]);
  const [isChecked2, setIsChecked2] = useState([1]);
  const [allSesion, setAllSesion] = useState(true);
  const [allStatus, setAllStatus] = useState(false);
  const [isPCChecked, setIsPCChecked] = useState([]);
  const [allPC, setAllPC] = useState(true);
  const [loading, setLoading] = useState(false);
  const [BgradeCheck, setBgradeCheck] = useState(false);
  const [check, setCheck] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [routineLog, setRoutineLog] = useState([]);
  const location = useLocation();
  const [sortClicked, setSortClicked] = useState(false);
  const [fitName, setFitName] = useState(null);
  const [productName, setProductName] = useState(null);
  const [genderName, setGenderName] = useState(null);
  const [seasonName, setSeasonName] = useState(null);
  const [yearName, setYearName] = useState(null);
  const [CatergoryName, setCatergoryName] = useState(null);
  const [sku, setSKU] = useState(null);
  const [styleName, setStyleName] = useState(null);
  const [washName, setWashName] = useState(null);
  const initialDate = moment("2026-12-31");
  const [sortedInfo, setSortedInfo] = React.useState({});
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 500,
    total: 0,
  });

  const { search } = useLocation();

  const query = new URLSearchParams(search);

  // const qp_status = query.get("current_status_id");
  // const qp_gender = query.get("gender_id");
  // const qp_style = query.get("style_id");
  // const qp_fit = query.get("fit_id");
  // const qp_date = query.get("as_on_date");

  let result =
    getWiseStockReport &&
    getWiseStockReport?.payload?.data?.reduce(function (r, a) {
      r[a.item_code] = r[a.item_code] || [];
      r[a.item_code].push(a);
      return r;
    }, Object.create(null));

  const wiseStockReport = result && Object.values(result);

  const values = {
    item_id: null,
    location_id: null,
  };

  const { Option } = Select;
  let pendingDate = "";

  const onChangeDate = (date, dateString) => {
    pendingDate = dateString;
  };

  const sesionSelectAll = (e) => {
    setAllSesion(e.target.checked);
  };
  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
    if (e.target.checked) {
      setIsChecked2([]);
    }
  };

  const isCheckboxChecked = (id, value) => {
    const filterCheckBox =
      season && season?.payload?.data.find((val) => val.season_id === id);
    const checkId = isChecked.includes(id);
    if (!checkId) {
      setIsChecked((current) => [...current, filterCheckBox.season_id]);
    }
    if (!value) {
      const removeUnCheck = isChecked.filter(
        (item) => item !== filterCheckBox.season_id
      );
      setIsChecked(removeUnCheck);
    }
    setAllSesion(false);
  };

  const isCheckboxChecked2 = (id, value) => {
    console.log("test", id, value);

    const filterCheckBox =
      productStatus &&
      productStatus?.payload?.data.find((val) => val.product_status_id === id);
    const checkId = isChecked2.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [
        ...current,
        filterCheckBox.product_status_id,
      ]);
    }
    if (!value) {
      const removeUnCheck = isChecked2.filter(
        (item) => item !== filterCheckBox.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };
  // console.log("isChecked2", isChecked2)
  // console.log("qp_status", qp_status)

  // useEffect(() => {
  //   const qp_status = query.get("current_status_id");
  //   const qp_gender = query.get("gender_id");
  //   const qp_style = query.get("style_id");
  //   const qp_cut = query.get("fit_id");
  //   // const qp_prod = query.get("fit_category_id");
  //   const qp_date = query.get("as_on_date");
  //   // 1. Set checkboxes from status array
  //   // console.log(qp_status, 'qp_status');

  //   if (productStatus?.payload?.data && qp_gender && !loading) {
  //     const newChecked =
  //       qp_status?.length > 0
  //         ? qp_status?.split(",").map((v) => Number(v?.trim()))
  //         : [];
  //     // console.log(newChecked, 'newChecked');

  //     setIsChecked2(
  //       qp_status?.length > 0
  //         ? qp_status?.split(",").map((v) => Number(v?.trim()))
  //         : []
  //     );

  //     // qp_status
  //     //   .split(",")
  //     //   .map(Number)
  //     //   .forEach(id => isCheckboxChecked2(id, true));

  //     // 2. Set all form fields from query
  //     form.setFieldsValue({
  //       gender_id: qp_gender && qp_gender !== "All" ? Number(qp_gender) : null,
  //       style_id: qp_style && qp_style !== "All" ? Number(qp_style) : null,
  //       cut_id: qp_cut && qp_cut !== "All" ? Number(qp_cut) : null,
  //       // fit_category_id: qp_prod && qp_prod !== "All" ? Number(qp_prod) : null,
  //       as_on_date: qp_date ? moment(qp_date, "MM-DD-YYYY") : moment(),
  //     });

  //     // 3. Jab sab filters set ho jaayein → API call karo
  //     // console.log(newChecked.every((v, i) => v === isChecked2[i]), 'newChecked.every((v,i) => v === isChecked2[i])');

  //     if (
  //       isChecked2?.length === newChecked?.length &&
  //       isChecked2?.every((v, i) => v === newChecked[i])
  //     ) {
  //       // console.log(isChecked2, 'isChecked2isChecked2');

  //       onFinish();
  //     }
  //   }
  // }, [query.get("current_status_id"), productStatus?.payload?.data]);

  // useEffect(() => {
  //   if (qp_status && productStatus?.payload?.data) {
  //     const statusArray = qp_status.split(",").map(Number);
  //     console.log("statusArray", statusArray)

  //     statusArray?.forEach(x => {
  //       console.log(x, true);
  //       isCheckboxChecked2(x, true)
  //     })
  //     onFinish();
  //   }
  //   form.setFieldsValue({
  //     gender_id: qp_gender && qp_gender !== "All" ? Number(qp_gender) : null,
  //     style_id: qp_style && qp_style !== "All" ? Number(qp_style) : null,
  //     fit_id: qp_fit && qp_fit !== "All" ? Number(qp_fit) : null,
  //     as_on_date: qp_date ? moment(qp_date, "MM-DD-YYYY") : moment(),
  //   });

  // }, [, query?.get("current_status_id"), productStatus?.payload?.data]);

  // useEffect(() => {
  //   if (location?.state && location?.state?.values?.new_season_id) {
  //     const values = {
  //       as_on_date: initialDate,
  //       sku: "",
  //       season_id: location?.state?.values?.new_season_id,
  //       gender_id: location?.state?.values?.gender_id,
  //       gender_category_id: null,
  //       cut_id: null,
  //       fit_category_id: null,
  //       style_id: null,
  //       product_status_id: null,
  //       product_class_id: null,
  //       sort_on: null,
  //       include_bgrade: "abc",
  //       wash_id: null,
  //       new_season_year_id: null,
  //     };
  //     form.setFieldsValue({
  //       season_id: values.season_id,
  //       gender_id: values.gender_id,
  //     });
  //     setLoading(true);
  //     dispatch(
  //       getOmsStockSummary(
  //         token,
  //         values,
  //         isChecked,
  //         isChecked2,
  //         isPCChecked,
  //         BgradeCheck
  //       )
  //     ).then((res) => {
  //       setLoading(false);
  //       setData(res?.payload?.data);
  //       downloadExcelFileData(res?.payload?.data);
  //     });
  //   }
  // }, [location?.state && location?.state?.values?.new_season_id]);

  // const onFinish = async (e) => {
  //   setLoading(true);
  //   await form.validateFields().then((values) => {
  //     dispatch(
  //       getOmsStockSummary(
  //         token,
  //         values,
  //         isChecked,
  //         isChecked2,
  //         isPCChecked,
  //         BgradeCheck
  //       )
  //     ).then((res) => {
  //       setLoading(false);
  //       setData(res?.payload?.data);
  //       downloadExcelFileData(res?.payload?.data);
  //     });
  //   });
  // };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Fabric": v.fabric_name,
          "Fabric Class": v.fabric_class,
          "No of SKU": v.noofsku,
          "Unit": v.fabric_quantity,
          "Required Meter": v.requiredmeter,
          "Fabric Stock": v.fabricstock,
          "Net": v.net,
          "On Order": v.on_order,
          "Balance": v.balance,
        };
      })
    );
  }

  // const handleTableChange = (pagination, filters, sorter) => {
  //   setSortedInfo(sorter);

  //   setPaginationInfo({
  //     current: pagination.current,
  //     pageSize: pagination.pageSize,
  //     total: data ? data.length : 0,
  //   });
  // };

  const getSortedData = (data, sortedInfo) => {
    if (!sortedInfo.order) return data;

    const { columnKey, order } = sortedInfo;
    return [...data].sort((a, b) => {
      const aValRaw = a[columnKey];
      const bValRaw = b[columnKey];

      const aVal = Number(
        typeof aValRaw === "string" ? aValRaw.replace(/,/g, "") : aValRaw
      );
      const bVal = Number(
        typeof bValRaw === "string" ? bValRaw.replace(/,/g, "") : bValRaw
      );

      if (isNaN(aVal)) return 1;
      if (isNaN(bVal)) return -1;

      if (order === "ascend") {
        return aVal - bVal;
      } else {
        return bVal - aVal;
      }
    });
  };

  // const handleDownloadPDF = () => {
  //   const columns = [
  //     "#",
  //     "Gender",
  //     "Current Season",
  //     "SKU",
  //     "Inseam",
  //     "Style",
  //     "Wash",
  //     "Fit Category",
  //     "WS",
  //     "RTL",
  //     "Total Sales Qty",
  //     "BERGEN",
  //     "TRNS",
  //     "PK",
  //     "PROD",
  //     "PEND",
  //     "INT",
  //     "OTS",
  //     "ECOM",
  //     "NORD",
  //     // "SAKS",
  //     "MODA",
  //     "MACYS",
  //     "Anthro",
  //     "AAFES",
  //     "POD",
  //     // "POD Amount"
  //   ];

  //   const rows = [];
  //   const sortedData = getSortedData(data, sortedInfo);
  //   sortedData.forEach((item, index) => {
  //     const row = [
  //       index + 1,
  //       item.gender,
  //       item.current_season,
  //       item.item_code,
  //       item.inseam,
  //       item.style,
  //       item.wash,
  //       item.fit_category,
  //       numeral(item.ws_price).format("$0,0"),
  //       numeral(item.retail_price).format("$0,0"),
  //       numeral(item.net_quantity).format("0,0"),
  //       numeral(item.bergan).format("0,0"),
  //       numeral(item.transit).format("0,0"),
  //       numeral(item.pakistan).format("0,0"),
  //       numeral(item.production).format("0,0"),
  //       numeral(item.pending).format("0,0"),
  //       numeral(item.international).format("0,0"),
  //       numeral(item.ots).format("0,0"),
  //       numeral(item.ecommerce).format("0,0"),
  //       numeral(item.nord).format("0,0"),
  //       // numeral(item.saks).format("0,0"),
  //       numeral(item.moda).format("0,0"),
  //       numeral(item.macys).format("0,0"),
  //       numeral(item.anthro).format("0,0"),
  //       numeral(item.aafes).format("0,0"),
  //       numeral(item.pod).format("0,0"),
  //       // numeral(item.pod_amount).format('0,0')
  //     ];
  //     rows.push(row);
  //   });

  //   generateDynamicPDF({
  //     filename: "Stock-Style-SKU-Report-Summary.pdf",
  //     headers: [
  //       genderName && { label: "Gender", value: genderName },
  //       fitName && { label: "Fit Category", value: fitName },
  //       seasonName && { label: "Season", value: seasonName },
  //       yearName && { label: "Season Year", value: yearName },
  //       CatergoryName && { label: "Category", value: CatergoryName },
  //       sku && { label: "Sku", value: sku },
  //       styleName && { label: "Style", value: styleName },
  //       washName && { label: "Wash", value: washName },
  //       isChecked2.length > 0 &&
  //       filterProductStatusName?.length > 0 && {
  //         label: "Product Status",
  //         value: filterProductStatusName
  //           .map((val) => val.product_status_name)
  //           .join(", "),
  //       },
  //       {
  //         label: "Pending Till",
  //         value: moment(form.getFieldValue("as_on_date")).format("MM-DD-YYYY"),
  //       },
  //     ].filter(Boolean), // removes any false/null values
  //     columns,
  //     rows,
  //     rowsRaw: sortedData,
  //     totalFields: [
  //       "net_quantity",
  //       "bergan",
  //       "transit",
  //       "pakistan",
  //       "production",
  //       "pending",
  //       "international",
  //       "ots",
  //       "ecommerce",
  //       "nord",
  //       // "saks",
  //       "moda",
  //       "macys",
  //       "anthro",
  //       "aafes",
  //       "pod",
  //       // "pod_amount",
  //     ],
  //     totalFieldIndexes: {
  //       net_quantity: 10,
  //       bergan: 11,
  //       transit: 12,
  //       pakistan: 13,
  //       production: 14,
  //       pending: 15,
  //       international: 16,
  //       ots: 17,
  //       ecommerce: 18,
  //       nord: 19,
  //       // saks: 19,
  //       moda: 20,
  //       macys: 21,
  //       anthro: 22,
  //       aafes: 23,
  //       pod: 24,
  //       // pod_amount: 24
  //     },
  //     totalLabelIndex: 9,
  //     rightAlignIndexes: [
  //       10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
  //       // 24
  //     ],
  //     margin: { top: 10, left: 5, right: 5, bottom: 2 },
  //   });
  // };

  useEffect(() => {
    // dispatch(getStyle(token, menuId));
    // dispatch(getProductType(token, values));
    // dispatch(getGenderCategory(token, menuId));
    // dispatch(getSeason(token, menuId));
    // dispatch(getProductStatus(token, menuId));
    // dispatch(getProductClass(token, menuId));
    // dispatch(getSize(token, menuId));
    // dispatch(getGender(token, menuId));
    // dispatch(getFitCategory(token, menuId));
    // dispatch(getFitCategoryNew(token, menuId));
    // dispatch(getWashName(token, menuId));
    // dispatch(getSeasonYear(token, menuId));

    const fetchFabricStock = async () => {
      setLoading(true);

      try {
        const res = await dispatch(getFabricStock(token));

        downloadExcelFileData(res?.payload?.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFabricStock();
  }, [dispatch, menuId, token]);

  // useEffect(() => {
  //   if (allSesion) {
  //     setIsChecked([]);
  //   }
  // }, [allSesion]);

  // useEffect(() => {
  //   if (allStatus) {
  //     setIsChecked2([]);
  //   }
  // }, [allStatus]);

  // useEffect(() => {
  //   if (isChecked2.length === 0) {
  //     setAllStatus(true);
  //   }
  // }, [isChecked2]);

  // useEffect(() => {
  //   if (allPC) {
  //     setIsPCChecked([]);
  //   }
  // }, [allPC]);

  const handlePrint = () => {
    const totalPages = Math.ceil(data?.length / paginationInfo?.pageSize);
    console.log(totalPages, "totalPages");
    let notificationKey = "print-warning";
    if (totalPages > 1) {
      notification.warning({
        message: "Printing Notice",
        description: `Data has ${totalPages} pages. Only page ${paginationInfo.current} will be printed.`,
        duration: 2,
        key: notificationKey,
      });
      setTimeout(() => {
        notification.close(notificationKey);
      }, 2000);
      setTimeout(() => {
        notification.close(notificationKey);
        const css = "@page { margin-top: 30px; margin-bottom: 30px }";
        const style = document.createElement("style");
        style.innerHTML = css;
        document.head.appendChild(style);
        window.print();
        document.head.removeChild(style);
      }, 3000); // Wait 2.5 seconds before printing
    } else {
      const css = "@page { margin-top: 30px; margin-bottom: 30px }";
      const style = document.createElement("style");
      style.innerHTML = css;
      document.head.appendChild(style);
      window.print();
      document.head.removeChild(style);
    }
  };

  // const columns = [
  //   {
  //     title: "#",
  //     render: (text, record, index) => {
  //       return index + 1;
  //     },
  //   },
  //   {
  //     title: "Gender",
  //     dataIndex: "gender",
  //     key: "gender",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.gender !== null) {
  //         return record.gender
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.gender !== null) & (b.gender !== null)) {
  //         return a.gender.localeCompare(b.gender);
  //       }
  //     },
  //   },
  //   {
  //     title: "Current Season",
  //     dataIndex: "current_season",
  //     key: "current_season",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.current_season !== null) {
  //         return record.current_season
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.current_season !== null) & (b.current_season !== null)) {
  //         return a.current_season.localeCompare(b.current_season);
  //       }
  //     },
  //   },
  //   {
  //     title: "SKU",
  //     dataIndex: "item_code",
  //     key: "item_code",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.item_code !== null) {
  //         return record.item_code
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.item_code !== null) & (b.item_code !== null)) {
  //         return a.item_code - b.item_code;
  //       }
  //     },
  //   },
  //   {
  //     title: "Inseam",
  //     dataIndex: "inseam",
  //     key: "inseam",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.inseam !== null) {
  //         return record.inseam
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.inseam !== null) & (b.inseam !== null)) {
  //         return a.inseam - b.inseam;
  //       }
  //     },
  //   },
  //   {
  //     title: "Style",
  //     dataIndex: "style",
  //     key: "style",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.style !== null) {
  //         return record.style
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.style !== null) & (b.style !== null)) {
  //         return a.style.localeCompare(b.style);
  //       }
  //     },
  //   },
  //   {
  //     title: "Wash",
  //     dataIndex: "wash",
  //     key: "wash",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.wash !== null) {
  //         return record.wash
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.wash !== null) & (b.wash !== null)) {
  //         return a.wash.localeCompare(b.wash);
  //       }
  //     },
  //   },
  //   {
  //     title: "Fit Category",
  //     dataIndex: "fit_category",
  //     key: "fit_category",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.fit_category !== null) {
  //         return record.fit_category
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.fit_category !== null) & (b.fit_category !== null)) {
  //         return a.fit_category.localeCompare(b.fit_category);
  //       }
  //     },
  //   },
  //   {
  //     title: "WS",
  //     dataIndex: "ws_price",
  //     key: "ws_price",
  //     render: (text, record) => {
  //       return <>$ {numeral(text).format("0,00.00")}</>;
  //     },
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.ws_price !== null) {
  //         return record.ws_price
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.ws_price !== null) & (b.ws_price !== null)) {
  //         return a.ws_price - b.ws_price;
  //       }
  //     },
  //   },
  //   {
  //     title: "RTL",
  //     dataIndex: "retail_price",
  //     key: "retail_price",
  //     render: (text, record) => {
  //       return <>$ {numeral(text).format("0,00.00")}</>;
  //     },
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.retail_price !== null) {
  //         return record.retail_price
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.retail_price !== null) & (b.retail_price !== null)) {
  //         return a.retail_price - b.retail_price;
  //       }
  //     },
  //   },
  //   {
  //     title: "Total Sales Qty",
  //     dataIndex: "net_quantity",
  //     key: "net_quantity",
  //     align: "right",
  //     render: (text, record) => {
  //       return <>{numeral(text).format("0,0")}</>;
  //     },
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.net_quantity !== null) {
  //         return record.net_quantity
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.net_quantity !== null) & (b.net_quantity !== null)) {
  //         return a.net_quantity - b.net_quantity;
  //       }
  //     },
  //   },
  //   {
  //     title: "BERGEN",
  //     dataIndex: "bergan",
  //     key: "bergan",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.bergan !== null) {
  //         return record.bergan
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.bergan !== null) & (b.bergan !== null)) {
  //         return a.bergan - b.bergan;
  //       }
  //     },
  //   },
  //   {
  //     title: "TRNS",
  //     dataIndex: "transit",
  //     key: "transit",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.transit !== null) {
  //         return record.transit
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.transit !== null) & (b.transit !== null)) {
  //         return a.transit - b.transit;
  //       }
  //     },
  //   },
  //   {
  //     title: "PK",
  //     dataIndex: "pakistan",
  //     key: "pakistan",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.pakistan !== null) {
  //         return record.pakistan
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.pakistan !== null) & (b.pakistan !== null)) {
  //         return a.pakistan - b.pakistan;
  //       }
  //     },
  //   },
  //   {
  //     title: "PROD",
  //     dataIndex: "production",
  //     key: "production",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.production !== null) {
  //         return record.production
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.production !== null) & (b.production !== null)) {
  //         return a.production - b.production;
  //       }
  //     },
  //   },
  //   {
  //     title: "PEND",
  //     dataIndex: "pending",
  //     key: "pending",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.pending !== null) {
  //         return record.pending
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.pending !== null) & (b.pending !== null)) {
  //         return a.pending - b.pending;
  //       }
  //     },
  //   },
  //   {
  //     title: "INT",
  //     dataIndex: "international",
  //     key: "international",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.international !== null) {
  //         return record.international
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.international !== null) & (b.international !== null)) {
  //         return a.international - b.international;
  //       }
  //     },
  //   },
  //   {
  //     title: "OTS",
  //     dataIndex: "ots",
  //     key: "ots",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.ots !== null) {
  //         return record.ots
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.ots !== null) & (b.ots !== null)) {
  //         return a.ots - b.ots;
  //       }
  //     },
  //   },
  //   {
  //     title: "ECOM",
  //     dataIndex: "ecommerce",
  //     key: "ecommerce",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.ecommerce !== null) {
  //         return record.ecommerce
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.ecommerce !== null) & (b.ecommerce !== null)) {
  //         return a.ecommerce - b.ecommerce;
  //       }
  //     },
  //   },
  //   {
  //     title: "NORD",
  //     dataIndex: "nord",
  //     key: "nord",

  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.nord !== null) {
  //         return record.nord
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.nord !== null) & (b.nord !== null)) {
  //         return a.nord - b.nord;
  //       }
  //     },
  //   },
  //   {
  //     title: "Moda",
  //     dataIndex: "moda",
  //     key: "moda",
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.moda !== null) {
  //         return record.moda
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.moda !== null) & (b.moda !== null)) {
  //         return a.moda - b.moda;
  //       }
  //     },
  //   },
  //   {
  //     title: "Macys",
  //     dataIndex: "macys",
  //     key: "macys",
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.macys !== null) {
  //         return record.macys
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.macys !== null) & (b.macys !== null)) {
  //         return a.macys - b.macys;
  //       }
  //     },
  //   },
  //   {
  //     title: "Anthro",
  //     dataIndex: "anthro",
  //     key: "anthro",
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.anthro !== null) {
  //         return record.anthro
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.anthro !== null) & (b.anthro !== null)) {
  //         return a.anthro - b.anthro;
  //       }
  //     },
  //   },
  //   {
  //     title: "AAFES",
  //     dataIndex: "aafes",
  //     key: "aafes",
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.aafes !== null) {
  //         return record.aafes
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.aafes !== null) & (b.aafes !== null)) {
  //         return a.aafes - b.aafes;
  //       }
  //     },
  //   },
  //   {
  //     title: "POD",
  //     dataIndex: "pod",
  //     key: "pod",
  //     align: "right",
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => {
  //       return (
  //         <>
  //           <Input
  //             allowClear
  //             autoFocus
  //             className="pop-search-gen pop-220 w-100"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onPressEnter={() => {
  //               confirm();
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}
  //           />
  //         </>
  //       );
  //     },
  //     filterIcon: (filtered) =>
  //       filtered ? <FilterFilled /> : <SearchOutlined />,
  //     onFilter: (value, record) => {
  //       if (record.pod !== null) {
  //         return record.pod
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase());
  //       }
  //     },
  //     sorter: (a, b) => {
  //       if ((a.pod !== null) & (b.pod !== null)) {
  //         return a.pod - b.pod;
  //       }
  //     },
  //   },
  // ];

  const columns = [
    {
      title: "S.#",
      width: 50,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Fabric",
      dataIndex: "fabric_name",
      key: "fabric_name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.fabric_name !== null) {
          return record.fabric_name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.fabric_name !== null) & (b.fabric_name !== null)) {
          return a.fabric_name.localeCompare(b.fabric_name);
        }
      },
    },
    {
      title: "Fabric Class",
      dataIndex: "fabric_class",
      key: "fabric_class",
      // width: 200,
      // align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.fabric_class !== null) {
          return record.fabric_class
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.fabric_class !== null) & (b.fabric_class !== null)) {
          return a.fabric_class.localeCompare(b.fabric_class);
        }
      },
    },
    {
      title: "No of SKU",
      dataIndex: "noofsku",
      key: "noofsku",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.noofsku !== null) {
          return record.noofsku
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.noofsku !== null) & (b.noofsku !== null)) {
          return a.noofsku - b.noofsku;
        }
      },
    },
    {
      title: "Unit",
      dataIndex: "fabric_quantity",
      key: "fabric_quantity",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.fabric_quantity !== null) {
          return record.fabric_quantity
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.fabric_quantity !== null) & (b.fabric_quantity !== null)) {
          return a.fabric_quantity - b.fabric_quantity;
        }
      },
    },
    {
      title: "Required Meter",
      dataIndex: "requiredmeter",
      key: "requiredmeter",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.requiredmeter !== null) {
          return record.requiredmeter
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.requiredmeter !== null) & (b.requiredmeter !== null)) {
          return a.requiredmeter - b.requiredmeter;
        }
      },
    },
    {
      title: "Fabric Stock",
      dataIndex: "fabricstock",
      key: "fabricstock",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.fabricstock !== null) {
          return record.fabricstock
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.fabricstock !== null) & (b.fabricstock !== null)) {
          return a.fabricstock - b.fabricstock;
        }
      },
    },
    {
      title: "Net",
      dataIndex: "net",
      key: "net",
      // width: 200,
      align: "right",
      render: (text, record) => {
        return numeral(record.net).format('0,0.00')
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.net !== null) {
          return record.net
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.net !== null) & (b.net !== null)) {
          return a.net - b.net;
        }
      },
    },
    {
      title: "On Order",
      dataIndex: "on_order",
      key: "on_order",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.on_order !== null) {
          return record.on_order
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.on_order !== null) & (b.on_order !== null)) {
          return a.on_order - b.on_order;
        }
      },
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      // width: 200,
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"

              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.balance !== null) {
          return record.balance
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.balance !== null) & (b.balance !== null)) {
          return a.balance - b.balance;
        }
      },
    },
  ];

  const qtyTotal = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.fabric_quantity),
    0
  );
  const qtyRequiredMeter = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.requiredmeter),
    0
  );
  const qtyFabricStock = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.fabricstock),
    0
  );
  const totalNet = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.net),
    0
  );
  const totalOnOrder = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.on_order),
    0
  );
  const totalBalance = fabricStockReport?.payload?.data.reduce(
    (acc, item, index) => acc + parseFloat(item.balance),
    0
  );


  // const handleGender = (gender_id) => {
  //   dispatch(getGenderCategoryChange(token, gender_id));
  //   dispatch(getStyleChange(token, gender_id, null, null));
  //   form.setFieldsValue({
  //     gender_category_id: "All",
  //     style_id: "All",
  //     sku: "All",
  //   });
  // };

  // const handleStyle = (gender_category_id) => {
  //   dispatch(
  //     getStyleChange(
  //       token,
  //       form.getFieldValue().gender_id,
  //       gender_category_id,
  //       null
  //     )
  //   );
  //   form.setFieldsValue({
  //     style_id: "All",
  //     sku: "All",
  //   });
  // };

  // const handleSku = (sku_id) => {
  //   if (sku_id === null) {
  //     dispatch(getSku(token, null, null, null));
  //   } else {
  //     dispatch(
  //       getSku(
  //         token,
  //         form.getFieldValue().gender_id,
  //         form.getFieldValue().gender_category_id,
  //         sku_id
  //       )
  //     );
  //   }
  //   form.setFieldsValue({
  //     sku: "All",
  //   });
  // };

  // function debounce(cb, delay = 1000) {
  //   let timeout;
  //   return (...args) => {
  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => {
  //       cb(...args);
  //     }, delay);
  //   };
  // }

  // const handleSkuSearch = () => {
  //   dispatch(getSku(token, null, null, null));
  // };

  // const optimizedFn = useCallback(debounce(handleSkuSearch), []);

  const filterProductStatusName = productStatus?.payload?.data?.filter((item) =>
    isChecked2.includes(item.product_status_id)
  );

  return (
    <div className="header_class business_header_oms" id="card-pdf">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"fabric-Stock.csv"}
                  data={excelData}
                  style={{ display: "flex" }}
                  onClick={() => { }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  />
                </CSVLink>
              </div>
              {/* <div className="print_icon printing_class">
                <input
                  type="image"
                  name="ImgPDF"
                  alt="Export to PDF"
                  id="ImgPDF"
                  title="Export to PDF"
                  src={pdf}
                  onClick={handleDownloadPDF}
                  style={{ borderWidth: "0px", height: "18px" }}
                />
              </div> */}
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Fabric Stock
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              <br />
            </span>
          </div>
          {/* Last Updated By:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {moment(routineLog[0]?.r_date +"T"+ routineLog[0]?.r_time).format('MM-DD-YYYY, hh:mm a')}
              </span> */}
        </div>
        <hr className="my-1" />

      </div>

      {/* <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allStatus} onChange={statusSelectAll}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              checked={
                                allStatus
                                  ? false
                                  : isChecked2.includes(it.product_status_id)
                              }
                              onChange={(e) =>
                                isCheckboxChecked2(
                                  it.product_status_id,
                                  e.target.checked
                                )
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Gender
                    </label>
                    <div className="w-100">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                          onChange={(e, obj) => setGenderName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season
                    </label>
                    <div className=" w-100">
                      <Form.Item name="season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().season_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                          onChange={(e, obj) => setSeasonName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.season_id}>
                                  {status.season_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season Year
                    </label>
                    <div className="w-100">
                      <Form.Item name="new_season_year_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          defaultValue={form.getFieldValue().new_season_year_id}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== "All"
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                          onChange={(e, obj) => setYearName(obj.children)}
                        >
                          <Option value={"All"}>All</Option>
                          {seasonYear?.payload?.data?.map((res) => (
                            <Option
                              key={res.season_year_id}
                              value={res.season_year_id}
                            >
                              {res.season_year}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Category
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e, obj) => setCatergoryName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {genderCategoryChange &&
                            genderCategoryChange?.payload?.data.length >= 0
                            ? genderCategoryChange &&
                            genderCategoryChange?.payload?.data.map(
                              (it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_id}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              }
                            )
                            : genderCategory &&
                            genderCategory?.payload?.data.map((it, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={it.gender_category_id}
                                >
                                  {it.gender_category_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Sku
                    </label>
                    <div className="w-100">
                      <Form.Item name="sku" initialValue={"All"}>
                        <Select
                          notFoundContent={
                            Sku.loading ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Loader
                                  type="Oval"
                                  color="#3c4b58"
                                  height={20}
                                  width={20}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                No Data
                              </div>
                            )
                          }
                          className={"select_Inputs"}
                          showSearch
                          onSearch={(value) => {
                            optimizedFn(value);
                          }}
                          optionFilterProp="children"
                          size="small"
                          onChange={(e, obj) => setSKU(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {Sku &&
                            Sku?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.sku}>
                                  {it.sku}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Style
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                          size="small"
                          onChange={(e, obj) => setStyleName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {styleChange && styleChange?.payload?.data.length >= 0
                            ? styleChange &&
                            styleChange?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })
                            : style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Wash
                    </label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e, obj) => setWashName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.wash_id}>
                                  {status.wash_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Fit Category
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="cut_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e, obj) => setFitName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {fitCategoryNew &&
                            fitCategoryNew?.payload?.data
                              ?.slice()
                              ?.sort((a, b) =>
                                a.cut_name.localeCompare(b.cut_name)
                              )
                              .map((item) => {
                                return (
                                  <Option
                                    defaultValue="All"
                                    key={item.cut_id}
                                    value={item.cut_id}
                                  >
                                    {item.cut_name}
                                  </Option>
                                );
                              })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Product Cat.
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="fit_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e, obj) => setProductName(obj.children)}
                        >
                          <Option value={null}>All</Option>
                          {fitCategory &&
                            fitCategory?.payload?.data
                              ?.sort((a, b) =>
                                a.fit_category_name.localeCompare(
                                  b.fit_category_name
                                )
                              )
                              .map((item) => {
                                return (
                                  <Option
                                    defaultValue="All"
                                    key={item.fit_category_id}
                                    value={item.fit_category_id}
                                  >
                                    {item.fit_category_name}
                                  </Option>
                                );
                              })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Pending Till
                    </label>
                    <div className="w-100">
                      <Form.Item
                        name="as_on_date"
                        className="full_date"
                        initialValue={initialDate}
                      >
                        <DatePicker size="small" format={dateFormatList} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Sort on
                    </label>
                    <div className="w-100">
                      <Form.Item
                        name="sorting"
                        className="full_date"
                        initialValue={"ots"} // <-- DEFAULT VALUE SET HERE
                      >
                        <Select size="small" style={{ width: "100%" }}>
                          <Option value="gender">Gender</Option>
                          <Option value="current_season">Current Season</Option>
                          <Option value="sku">Sku</Option>
                          <Option value="style">Style</Option>
                          <Option value="wash">Wash</Option>
                          <Option value="fit_category">Fit Category</Option>
                          <Option value="ots">OTS</Option>

                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "3px",
                        float: "right",
                      }}
                    >
                      <Button
                        style={{ width: "fit-content" }}
                        type="primary"
                        htmlType="submit"
                        className="submit-btn-btm m-0"
                      >
                        Generate
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div> */}
      <div>
        <div
        // style={{
        //   overflowY: "scroll",
        //   height: "57vh",

        // }}
        >
          {
            fabricStockReport?.payload?.data !== undefined ?
              (
                fabricStockReport?.payload?.data.length > 0 ? (
                  <div id="card">
                    <Table
                      className=" border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border omsTable width-fabric-stock-table"
                      ref={tableRef}
                      size="small"
                      bordered={false}
                      type="company"
                      headerClassName="abc"
                      dataSource={fabricStockReport?.payload.data || []}
                      columns={columns}
                      scroll={{ x: "max-content" }}
                      loading={fabricStockReport.loading}
                      // onChange={handleTableChange}
                      pagination={{
                        defaultCurrent: 1,
                        defaultPageSize: 500,
                        pageSizeOptions: [
                          100, 500, 1000, 2000, 2500, 3000, 9000, 15000,
                        ],
                      }}
                      summary={(pageData) => {
                        return (
                          <>
                            <Table.Summary.Row>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "center", margin: "0" }}>
                                  Total &gt; &gt; &gt;
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {qtyTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {qtyRequiredMeter.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {qtyFabricStock.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {totalNet.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {totalOnOrder.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p
                                  style={{ textAlign: "right", margin: "0" }}
                                  className="totalquantity"
                                >
                                  {totalBalance.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>

                            </Table.Summary.Row>
                          </>
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div className="no-Data">
                    {/* {} */}
                    <h1>No Data</h1>
                  </div>
                )
              ) : (
                loading && (
                  <div className="loader" style={{ marginTop: "20px" }}>
                    <Spin size="medium" />
                  </div>
                )
              )}
        </div>
      </div>
    </div>
  );
};

export default FabricStock;
